import owd from 'owd/owd';

export default class TicketsHero extends owd.Component {
    init() {
        this.bind();
    }

    bind() {
        this.on('load ajaxload resize-x', this.dom.$window, () => {
            this.$navHeight = $('.tickets-nav').outerHeight();
            this.$windowHeight = window.innerHeight;

            if (window.innerWidth < 1024) {
                this.$navHeight = $('.tickets-nav--mobile').outerHeight();
            }

            this.$element.css('height', this.$windowHeight - this.$navHeight);
        });

        this.dom.$window.trigger('load');
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('tickets-hero', {
    component: TicketsHero
});
